import ChartEditor from './ChartEditor';

export default ChartEditor;
